import { AfterViewInit, Component, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { TasDataSource } from 'src/app/services/tasGovTable.datasource';
import { PropertyTaxDialogComponent } from '../../dialogs/property-tax-dialog/property-tax-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lot-list',
  templateUrl: './lot-list.component.html',
  styleUrls: ['./lot-list.component.css']
})
export class LotListComponent implements OnInit, AfterViewInit {
  currentFilter = {}
  displayedColumns: string[] = ['lotId', 'municipality', 'district', 'ilot'];
  dataSource: TasDataSource;
  @Output() type: string;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  loading = { inProgress: false, downloadInProgress: false }
  currentUser
  constructor(private propertyTaxService: PropertyTaxService, private userService: UserService,
    private translate: TranslateService,
    private router: Router,
    public dialog: MatDialog) { }

  async ngOnInit() {
    this.dataSource = new TasDataSource(this.propertyTaxService)
    this.currentUser = await this.userService.getCurrentUser().toPromise();

  }

  async loadPropertyTaxTable() {
    this.dataSource.loadData(
      "property-tax/lots",
      "",
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.currentFilter,
      this.loading
    );
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadPropertyTaxTable())
      )
      .subscribe();
  }
  getCompanyName(el) {
    let rows = el.attributes?.rows
    if (rows) {
      let n = rows.find(elem => elem.companyName)
      if (n)
        return (n.companyName)
    }
    return ''
  }
  advancedSearch(val) {
    this.currentFilter = val
    if (!this.currentFilter['municipality'] && localStorage.getItem('municipality')) {
      this.currentFilter['municipality'] = [localStorage.getItem('municipality')]
    }
    this.loadPropertyTaxTable()
  }

  reset() {
    this.currentFilter = {};
  }

  openPropertyTaxDialog(propertyTax) {
    const dialogRef = this.dialog.open(PropertyTaxDialogComponent, {
      width: '800px', panelClass: 'custom-dialog-container',
      data: propertyTax
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  goToMatchRequest(lot) {
    this.router.navigate(['lot-editor'], { queryParams: { lotId: lot.lot.id } });
  }

  downloadReport() {
    let headers = [
      { header: this.translate.instant("PROPERTY-TAX.TABLE_COLUMN_MUNICIPALITY"), key: 'municipality', skey:'name' },
      { header: this.translate.instant("PROPERTY-TAX.TABLE_COLUMN_DISTRICT"), key: 'district', skey:'name' },
      { header: this.translate.instant("PROPERTY-TAX.TABLE_COLUMN_ILOT"), key: 'ilot', skey:'name' },
    ]

    this.loading.downloadInProgress = true
    this.propertyTaxService.downloadLotListReport(this.currentFilter, headers).subscribe
      (data => {
        this.loading.downloadInProgress = false
        const blob = data;
        const file = new Blob([blob], {});
        const filename = 'document_' + Date.now() + '.zip';
        saveAs(file, filename);
      });
  }
  canDownloadReport() {
    if (this.currentUser) {
      return ['ADMIN', 'PROPERTIES_EDITOR'].includes(this.currentUser.role)
    }
    return false
  }
}
